// NOTE: when adding new events please add documentation to:
// https://docs.google.com/spreadsheets/d/1xwTm45jHojFxeO5UyCF1hxkooeaoQ7c5JczcTznkmqg/edit#gid=367769533

enum OrderClientEventName {
  DataScanAttempted = 'data-scan-attempted',
  SessionStart = 'session-start',
  SessionAbandon = 'session-abandon',
  SessionEnd = 'session-end',
  SessionExit = 'session-exit',
  CoverPromoClicked = 'cover-promo-clicked',
  FulfillmentOpeningStart = 'fulfillment-opening-start',
  FulfillmentOpeningCancel = 'fulfillment-opening-cancel',
  FulfillmentOpeningEnd = 'fulfillment-opening-end',
  MenuItemView = 'menu-item-view',
  MenuItemScan = 'menu-item-scan',
  MenuItemAbandon = 'menu-item-abandon',
  MenuItemAddToCart = 'menu-item-add-to-cart',
  MenuItemRemoveFromCart = 'menu-item-remove-from-cart',
  FulfillmentCheckoutStart = 'fulfillment-checkout-start',
  FulfillmentCheckoutCancel = 'fulfillment-checkout-cancel',
  FulfillmentCheckoutEnd = 'fulfillment-checkout-end',
  CheckoutStart = 'checkout-start',
  CheckoutCancel = 'checkout-cancel',
  CheckoutEnd = 'checkout-end',
  PaymentCreditCardStart = 'payment-credit-card-start',
  PaymentCreditCardCancel = 'payment-credit-card-cancel',
  PaymentCreditCardEnd = 'payment-credit-card-end',
  PaymentCreditCardError = 'payment-credit-card-error',
  OrderSendStart = 'order-send-start',
  OrderSendEnd = 'order-send-end',
  OrderSendError = 'order-send-error',
  OrderSendErrorOutOfSync = 'order-send-error-out-of-sync',
  OrderFailedToGet = 'order-failed-to-get',
  TipAdd = 'tip-add',
  TipRemove = 'tip-remove',
  TipEdit = 'tip-edit',
  TipViewRender = 'tip-view-render',
  TipViewDismiss = 'tip-view-dismiss',
  TipViewSuccess = 'tip-view-success',
  OrderSummaryStepViewRender = 'order-summary-step-view-render',
  OrderSummaryStepShowTipView = 'order-summary-step-show-tip-view',
  OrderSummaryStepOrderDidValidate = 'order-summary-step-order-did-validate',
  OrderSummaryStepTipDidValidate = 'order-summary-step-tip-did-validate',
  OrderSummaryStepEnableControlButtons = 'order-summary-step-enable-control-buttons',
}

export { OrderClientEventName };
